import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { useClientProfile } from 'src/entities/client';

export const useMainResumeId = (): ApiServerEntityIDType | undefined => {
  const clientProfile = useClientProfile();
  return clientProfile?.mainResumeId;
};
